export default __webpack_public_path__ + "assets/pdf/FT_ZVKu.7c72367f.pdf";